export default __webpack_public_path__ + "static/media/2.77ac4bb8.png";